import React from 'react';
import Link from 'next/link';

import { IMenuByTypesItem } from '@r1-frontend/api-domru/api-content/v2/menu/by-types/dto/IMenuByTypesItem';
import Accordion from '@r1-frontend/entities/Layout/Header/mobile/components/Accordion';
import * as ST from '@r1-frontend/entities/Layout/Header/mobile/styled';

interface IProps {
    menuItems: IMenuByTypesItem[],
    analytics: string,
    onClick: (item?: string, menuType?: string) => void,
    clickHandler?: () => void,
}

const TopMenu = ({
    menuItems,
    onClick,
    analytics,
}: IProps): JSX.Element => {
    return (
        <>
            {menuItems?.map(item => (
                <Accordion
                    link={item.link}
                    key={`mobile-accordion-${item.id}`}
                    title={item.title}
                    isVisible={item?.children && item?.children[0]?.children?.length > 1 || item?.children?.length > 1}
                    isAvailable={!!item.available}
                    isPromoted={!!item.promoted}
                >
                    <ST.MobileTopMenuItemBlock>
                        {item?.children?.map((itemChild) => (
                            itemChild?.children?.map((child) =>
                                <ST.MobileTopMenuItem
                                    key={`mobile-child-${child.id}`}
                                    data-test='top-menu-item-abn'
                                >
                                    <Link href={child.link} prefetch={false} passHref>
                                        <ST.LinkItemDrop
                                            onClick={() => onClick(child.title, analytics)}
                                        >
                                            {child.title}
                                        </ST.LinkItemDrop>
                                    </Link>
                                </ST.MobileTopMenuItem>)
                        ))
                        }
                    </ST.MobileTopMenuItemBlock>
                </Accordion>
            ))}
        </>
    );
};

export default TopMenu;
